// extracted by mini-css-extract-plugin
export default {"breakdownRow":"NutritionDrawer_breakdownRow__VLfH9"};